import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux-store/appStore';
import { SubscriptionPage } from 'src/pages/Subscription/SubscriptionPage';
import {
  canAccessSubscriptions,
  getPermitFeatureDeniedRedirect
} from 'src/utils/permitFeatureAccess';

const SubscriptionRoute = () => {
  const userDetails = useSelector((store: RootState) => store.user.userDetails);

  if (!canAccessSubscriptions(userDetails)) {
    return (
      <Navigate
        to={getPermitFeatureDeniedRedirect(userDetails)}
        replace
      />
    );
  }

  return <SubscriptionPage />;
};

export default SubscriptionRoute;
